<template>
    <div class="rewards">
        <div class="list-container">
            <div>
                <p class="list-title">Reward Links</p>
                <p class="list-count">Count: {{ ads.length }}</p>
            </div>
        </div>
    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js'

export default {
    computed: {
        client_id () { return this.$store.state.client_id },
        ads () { return this.$store.state.DB.ads }
    },
    mounted () {

    },
    methods: {
        getAds ( client_id ) {
            WebSoc.SEND('search',{ DB: 'jb-ads', find: { client_id: client_id } },ads => {
                console.log('ads',client_id,ads);
                console.log('this.ads',JSON.parse(JSON.stringify(this.ads)));
                ads.forEach(ad => {
                    Array.isArray(ad.dLinked) && ad.dLinked.forEach(l => console.log(ad.title,new Date(l.date),l));
                })
            })
        }
    }
}    
</script>